export default "__VITE_ASSET__8c2eba82__"